import type { QueryKey } from '@tanstack/react-query';

import useInfiniteQuery from '../../../ReactQuery/useInfiniteQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetComponentResponse } from '../../../../shared/types/routes/binary';

export const getComponentsQueryKey = (
  revisionLocator: string,
  depLocator: string,
  pageSize: number,
): QueryKey => ['binary', revisionLocator, depLocator, 'components', pageSize];

function fetchComponents({ pageParam = 0 }, revisionLocator: string, depLocator: string, pageSize: number) {
  return get<GetComponentResponse>(`/api/binary/${nuc(revisionLocator)}/${nuc(depLocator)}/components`, false, {
    pageSize,
    page: pageParam,
  });
}

/**
 * Helper hook for fetching the components of a given binary dependency in a user's revision.
 * @param revisionLocator - The revision locator of the user's revision.
 * @param depLocator - The locator of the dependency to fetch components for.
 * @param pageSize - The number of components to fetch per page.
 * @returns An infinite query for the components of the given dependency.
 */
export default function useGetComponents(revisionLocator: string, depLocator: string, pageSize: number) {
  return useInfiniteQuery<GetComponentResponse>({
    queryKey: getComponentsQueryKey(revisionLocator, depLocator, pageSize),
    queryFn: (context) => fetchComponents(context, revisionLocator, depLocator, pageSize),
  });
}
